import React, { useState, useEffect } from "react";
import { useQuery, useManualQuery, useMutation, ClientContext } from "graphql-hooks";

import { useParams, useNavigate } from "react-router-dom";

import {
  Grid,
  Checkbox,
  Button,
  Typography,
  IconButton,
  makeStyles,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import update from "immutability-helper";

import Link from "@mui/material/Link";

const useStyles = makeStyles(theme => ({
  outlinedButtonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#0D47A1",
    height: "34px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    "&:active": {
      backgroundColor: "#0D47A1",
    },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
}));

export default function ApplicantInfoDialog({
  selectedApplicant,
  selectedApplicantDateApplied,
  closeDialog,
}) {
  const classes = useStyles();
  const [open, setOpen] = useState(true);

  const navigate = useNavigate();

  const handleClose = () => {
    setOpen(false);
    closeDialog && closeDialog();
  };

  const linkedinUrl =
    selectedApplicant?.linkedinUrl &&
    (selectedApplicant.linkedinUrl.startsWith("http://") ||
      selectedApplicant.linkedinUrl.startsWith("https://"))
      ? selectedApplicant.linkedinUrl
      : `https://${selectedApplicant?.linkedinUrl}`;

  return (
    <div style={{ width: "100%", minWidth: 600 }}>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            "& .MuiPaper-root": {
              minWidth: "600px",
            },
          },
        }}
      >
        <DialogTitle
          sx={{ m: 0, p: 2 }}
          id="alert-dialog-title"
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <Grid
            container
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <Grid
              item
              xs={11}
              style={{
                textAlign: "center",
                paddingLeft: 15,
              }}
            >
              Applicant Information
            </Grid>
            <Grid item xs={1}>
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  align: "right",
                  color: theme => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Box
              pt={2}
              style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
            >
              <Typography style={{ paddingRight: 5, color: "black" }} variant="h2">
                Applicant Name:
              </Typography>
              {selectedApplicant && (
                <Typography variant="h3">
                  {selectedApplicant.firstName} {selectedApplicant.lastName}
                </Typography>
              )}
            </Box>

            <Box
              pt={2}
              style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
            >
              <Typography style={{ paddingRight: 5, color: "black" }} variant="h2">
                Date Applied:
              </Typography>
              <Typography variant="h3">{selectedApplicantDateApplied}</Typography>
            </Box>

            <Box
              pt={2}
              style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
            >
              <Typography style={{ paddingRight: 5, color: "black" }} variant="h2">
                Email:
              </Typography>
              {selectedApplicant && (
                <Typography variant="h3">{selectedApplicant.email}</Typography>
              )}
            </Box>

            <Box
              pt={2}
              style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
            >
              <Typography style={{ paddingRight: 5, color: "black" }} variant="h2">
                LinkedIn URL:
              </Typography>
              {selectedApplicant?.linkedinUrl && (
                <Typography variant="h3">
                  <Link
                    href={linkedinUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    underline="hover"
                  >
                    {selectedApplicant.linkedinUrl}
                  </Link>
                </Typography>
              )}
            </Box>

            <Box
              pt={2}
              style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
            >
              <Typography style={{ paddingRight: 5, color: "black" }} variant="h2">
                Phone No:
              </Typography>
              {selectedApplicant && (
                <Typography variant="h3">{selectedApplicant.phoneNo}</Typography>
              )}
            </Box>

            <Box
              pt={2}
              style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
            >
              <Typography style={{ paddingRight: 5, color: "black" }} variant="h2">
                City:
              </Typography>
              {selectedApplicant && (
                <Typography variant="h3">{selectedApplicant.city}</Typography>
              )}
            </Box>

            <Box
              pt={2}
              style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
            >
              <Typography style={{ paddingRight: 5, color: "black" }} variant="h2">
                State:
              </Typography>
              {selectedApplicant && (
                <Typography variant="h3">{selectedApplicant.state}</Typography>
              )}
            </Box>

            <Box
              pt={2}
              style={{ display: "flex", flexDirection: "row", alignItems: "center" }}
            >
              <Typography style={{ paddingRight: 5, color: "black" }} variant="h2">
                Country:
              </Typography>
              {selectedApplicant && (
                <Typography variant="h3">{selectedApplicant.country}</Typography>
              )}
            </Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ justifyContent: "center" }}>
          <Box mb={2}>
            <Button
              variant="contained"
              color="primary"
              className={classes.buttonStyle}
              style={{ marginRight: 5, width: "100px" }}
              onClick={handleClose}
            >
              Done
            </Button>
          </Box>
        </DialogActions>
      </Dialog>
    </div>
  );
}
